import React, { useEffect, useState } from "react";
import BackButton from "../generic/elements/backbutton/BackButton";
import { executeIntent } from "../utils/IntentExecutor";
import IntentType from "../../intentexecutor/utils/IntentType";
import ServicesSettings from "./servicesettings/ServicesSettings";
import { useGetOrgIdentifier } from "../generic/hooks/useGetOrgIdentifier";
import { Row, Col, Card } from "antd";
import ConfigurationConstants from "../utils/configurationconstants";
import { currentConfiguration } from "../../service/memory/recoil/configurationstore";
import { useRecoilValue } from "recoil";
import { notifiyUser } from "../utils/Notification";
import { strings } from "../utils/strings";
import SetDashboardDataValuesComponent from "./profilepages/components/SetDashboardDataValuesComponent";
import MemoryType from "../../service/memory/enum/MemoryType";
import { useReadMemory } from "../generic/hooks/useReadMemory";
import { publishEvent } from "../../components/generic/EventPublisher";
import "./organization.css"
import FacilitiesSettings from "./facilities/FacilitiesSettings";
import TeamSettings from "./teams/TeamSettings";
import OfficeSettings from "./office/OfficeSettings";

const OrganizationSettingsPage = () => {
	const [selectedServices, setSelectedServices] = useState([]);
	const [services, setServices] = useState([]);
	const organizationIdentifier = useGetOrgIdentifier();
	const [isServicesLoading, setIsServicesLoading] = useState(false);
	const [isSelectedServicesLoading, setIsSelectedServicesLoading] = useState(false);
	const [serviceToBeEdited, setServiceToBeEdited] = useState({});
	const [isOfficesAllowed, setIsOfficesAllowed] = useState(false);
	const [isTeamsAllowed, setIsTeamsAllowed] = useState(false);
	const [isFacilitiesAllowed, setIsFacilitiesAllowed] = useState(false);
	const configuration = useRecoilValue(currentConfiguration);

	const userDetails = useReadMemory(MemoryType.USER);

	useEffect(() => {
		const configurationOffices = configuration[ConfigurationConstants.FEATUREACCESS_OFFICE_ADD];
		setIsOfficesAllowed(configurationOffices?.visibility);		
		const configurationTeams = configuration[ConfigurationConstants.FEATUREACCESS_TEAMS_ADD];
		setIsTeamsAllowed(configurationTeams?.visibility);		
		const configurationFacilities = configuration[ConfigurationConstants.FEATUREACCESS_FACILITIES_ADD];
		setIsFacilitiesAllowed(configurationFacilities?.visibility);
	}, [configuration]);

	const getServices = async () => {
		setIsServicesLoading(true);

		const payload = {
			configurationKey: ["niramaya.organization.volunteerduties"],
		};

		const result = await executeIntent(IntentType.GET_CONFIGURATION, payload, {});
		const servicesList = result[0].configurationValue && JSON.parse(result[0].configurationValue);
		setServices(servicesList);
		setIsServicesLoading(false);
	};

	const getAddedServices = async () => {
		setIsSelectedServicesLoading(true);

		const payload = {
			configurationKey: ["niramaya.organization.volunteerduties"],
		};
		let result = await executeIntent(IntentType.GET_CONFIGURATION, payload, {
			organizationIdentifier: organizationIdentifier,
		});

		const service = result[0]?.configurationValue && JSON.parse(result[0]?.configurationValue);
		if (result[0].context) {
			setSelectedServices(service);
		}

		setIsSelectedServicesLoading(false);
	};

	const addServices = async (servicesList, service, servicesOption) => {
		const payload = {
			configurationKey: "niramaya.organization.volunteerduties",
			configurationValue: JSON.stringify(servicesList),
		};

		const result = await executeIntent(IntentType.ADD_CONFIGURATION, payload, {
			organizationIdentifier: organizationIdentifier,
		});
		if (servicesOption === "create service") {			
			publishEvent("niramaya.organization.service.added", userDetails, servicesList[servicesList.length-1])
			notifiyUser(result, strings.SERVICES_CREATED_SUCCESS, strings.SERVICES_CREATED_ERROR);
		}
		else if (servicesOption === "delete service") {
			publishEvent("niramaya.organization.service.removed", userDetails, service)
			notifiyUser(result, strings.SERVICES_DELETED_SUCCESS, strings.SERVICES_DELETED_ERROR);
		}
		else if (servicesOption === "edit service") {
			publishEvent("niramaya.organization.service.updated", userDetails, servicesList[service], serviceToBeEdited)
			notifiyUser(result, strings.SERVICES_UPDATED_SUCCESS, strings.SERVICES_UPDATED_ERROR);
		}
		else {
			publishEvent("niramaya.organization.service.added", userDetails, service)
			notifiyUser(result, strings.SERVICES_ADDED_SUCCESS, strings.SERVICES_ADDED_ERROR);
		}
	};

	const editServices = async (service) => {
		const payload = {
			configurationKey: [service.serviceKey],
		};

		const result = await executeIntent(IntentType.GET_CONFIGURATION, payload, {
			organizationIdentifier: organizationIdentifier,
		});
		setServiceToBeEdited({ ...result[0], ...service });
		return { ...result[0], ...service };
	};

	useEffect(() => {
		getAddedServices();
	}, [services, serviceToBeEdited]);

	return (
		<section className="section-content">
			<div className="form-renderer-back-button">
				<BackButton />
				<p>Organization Profile</p>
			</div>
			<Row>
				<Col xs={24}>
					<Card className="organization-settings-card">
						<SetDashboardDataValuesComponent />
					</Card>
				</Col>
			</Row>
			<Row gutter={[20, 20]}>
				<Col xs={24} xl={12}>
					<ServicesSettings
						masterServices={services}
						receivedSelectedServices={selectedServices}
						isServicesLoading={isServicesLoading}
						isSelectedServicesLoading={isSelectedServicesLoading}
						addServices={addServices}
						getServices={getServices}
						deleteService={addServices}
						editServices={editServices}
						serviceToBeEdited={serviceToBeEdited}
						isOrganizationProfilePage={true}
					/>
				</Col>

				{
					isOfficesAllowed &&
					<Col xs={24} xl={12}>
						<OfficeSettings />
					</Col>
				}
				{
					isTeamsAllowed &&
					<Col xs={24} xl={12}>
						<TeamSettings />
					</Col>
				}
				{
					isFacilitiesAllowed &&
					<Col xs={24} xl={12}>
						<FacilitiesSettings />
					</Col>
				}
			</Row>
		</section>
	);
};

export default OrganizationSettingsPage;
